import React, { Component } from "react";
import "./productos.css";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import Navbar from "../../componentes/navbar/navbar";
import { toast } from "react-toastify";
import { agregarNuevo, editarProducto, getListaProductos } from "../../service/api";
import { FaTrashAlt } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import ProductoModal from "../../componentes/modal/ProductoModal";
import ModalMessage from "../../componentes/modal/ModalMessages/ModalMessages";

export default class ProductosPage extends Component {
  state = {
    loading: false,
    productos: [],

    sortKey: "producto",
    sortDir: "asc",

    verProductos: false,
    accionEstatus: "deshabilitar",
    banderatipo: "create",
    productoSeleccionado: {},
    verMensaje: false,
    modalMessage: "",

    q: "",
    estatus: "all",

    selectedRowId: null, // ✅ fila seleccionada (toggle)
  };

  componentDidMount() {
    const datos = localStorage.getItem("datosm");
    if (!datos || datos === "") {
      window.location.href = "/";
      return;
    }
    this.fetchProductos();
  }

  // ====== HELPERS ======
  compareValues = (a, b) => {
    if (a == null) a = "";
    if (b == null) b = "";

    const na = Number(a);
    const nb = Number(b);

    const bothNumeric =
      !Number.isNaN(na) &&
      !Number.isNaN(nb) &&
      String(a).trim() !== "" &&
      String(b).trim() !== "";

    if (bothNumeric) return na - nb;

    return String(a).localeCompare(String(b), "es", {
      numeric: true,
      sensitivity: "base",
    });
  };

  estatusLabel = (idestatus) => (Number(idestatus) === 1 ? "Activo" : "Inactivo");

  normalizeProducto = (p) => {
    const idestatus = p?.idestatus ?? 0;
    const idproducto = p?.idproducto ?? "-";

    return {
      idproducto,
      sku: p?.sku ?? "-",
      producto: p?.producto ?? "-",
      clave_sat: p?.clave_sat ?? "-",
      idestatus,
      estatusTxt: this.estatusLabel(idestatus),
      _key: String(idproducto ?? Math.random()),
      _rowId: String(idproducto ?? Math.random()),
    };
  };

  fetchProductos = async () => {
    this.setState({ loading: true });

    try {
      const resp = await getListaProductos();

      if (resp?.code === 0) {
        const raw = resp?.data || [];
        const arr = Array.isArray(raw) ? raw : raw?.data || [];
        const productos = (arr || []).map(this.normalizeProducto);

        this.setState({ productos, selectedRowId: null });
      } else {
        toast.info(resp?.message || "No se pudieron obtener los productos.");
        this.setState({ productos: [], selectedRowId: null });
      }
    } catch (e) {
      this.setState({ productos: [], selectedRowId: null });
      toast.info("Error consultando productos.");
    } finally {
      this.setState({ loading: false });
    }
  };

  // ====== FILTROS ======
  onChangeSearch = (e) => {
    const q = e.target.value;
    this.setState({ q, selectedRowId: null });
  };

  onChangeEstatus = (e) => {
    const estatus = e.target.value;
    this.setState({ estatus, selectedRowId: null });
  };

  getFiltered = (list = this.state.productos) => {
    const { q, estatus } = this.state;

    const qq = String(q || "").trim().toLowerCase();
    let filtered = [...(list || [])];

    if (estatus !== "all") {
      const est = Number(estatus);
      filtered = filtered.filter((p) => Number(p.idestatus) === est);
    }

    if (qq) {
      filtered = filtered.filter((p) => {
        const sku = String(p.sku || "").toLowerCase();
        const prod = String(p.producto || "").toLowerCase();
        const sat = String(p.clave_sat || "").toLowerCase();
        return sku.includes(qq) || prod.includes(qq) || sat.includes(qq);
      });
    }

    return filtered;
  };

  // ====== ORDEN ======
  getSortValue = (p, key) => {
    switch (key) {
      case "sku":
        return p.sku;
      case "producto":
        return p.producto;
      case "clave_sat":
        return p.clave_sat;
      case "estatus":
        return p.estatusTxt;
      default:
        return "";
    }
  };

  onSort = (key) => {
    this.setState((prev) => {
      const same = prev.sortKey === key;
      const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
      return { sortKey: key, sortDir: nextDir, selectedRowId: null };
    });
  };

  getSortedItems = () => {
    const { sortKey, sortDir } = this.state;

    const filtered = this.getFiltered();

    return [...filtered].sort((pa, pb) => {
      const a = this.getSortValue(pa, sortKey);
      const b = this.getSortValue(pb, sortKey);
      const cmp = this.compareValues(a, b);
      return sortDir === "asc" ? cmp : -cmp;
    });
  };

  // ✅ Toggle selección
  onSelectRow = (rowId) => {
    this.setState((prev) => ({
      selectedRowId: prev.selectedRowId === rowId ? null : rowId,
    }));
  };

  borrarItem = (item) => {
    const esActivo = Number(item.idestatus) === 1;

    this.setState({
      productoSeleccionado: item,
      verMensaje: true,
      modalMessage: item.producto,
      accionEstatus: esActivo ? "deshabilitar" : "activar",
      selectedRowId: item?._rowId ?? null,
    });
  };

  completaBorrar = async (bandera) => {
    if (bandera !== 1) {
      this.setState({
        verMensaje: false,
        modalMessage: "",
        productoSeleccionado: {},
        accionEstatus: "",
      });
      return;
    }

    const item = this.state.productoSeleccionado;
    const id = item?.idproducto;

    if (!id) {
      this.setState({ verMensaje: false });
      toast.info("No se encontró el id del producto.");
      return;
    }

    const activar = this.state.accionEstatus === "activar";
    const nextStatus = activar ? 1 : 2;

    const payload = {
      sku: item.sku,
      producto: item.producto,
      clave_sat: item.clave_sat,
      idestatus: nextStatus,
    };

    try {
      this.setState({ loading: true, verMensaje: false });

      const resp = await editarProducto(id, payload);

      if (resp?.code === 0) {
        toast.success(activar ? "Producto activado" : "Producto deshabilitado");
        this.fetchProductos();
      } else {
        this.setState({ loading: false });
        toast.info(resp?.message || "Ocurrió un error.");
      }
    } catch (e) {
      toast.info("Error al actualizar estatus.");
    }
  };

  nuevoProducto = () => {
    this.setState({
      banderatipo: "create",
      productoSeleccionado: null,
      verProductos: true,
      selectedRowId: null,
    });
  };

  editarDetalles = (item) => {
    this.setState({
      banderatipo: "edit",
      productoSeleccionado: item,
      verProductos: true,
      selectedRowId: item?._rowId ?? null,
    });
  };

  saveProducto = async (payload) => {
    const { banderatipo, productoSeleccionado } = this.state;

    try {
      this.setState({ loading: true });

      let resp;

      if (banderatipo === "create") {
        resp = await agregarNuevo(payload);
      } else {
        const id = productoSeleccionado?.idproducto;
        if (!id) {
          this.setState({ loading: false });
          toast.info("No se encontró el id del producto para actualizar.");
          return;
        }
        resp = await editarProducto(id, payload);
      }

      if (resp?.code === 0) {
        toast.success(
          banderatipo === "create"
            ? "Producto agregado correctamente."
            : "Producto actualizado correctamente."
        );
        this.setState({ verProductos: false });
        this.fetchProductos();
      } else {
        this.setState({ loading: false });
        toast.info(resp?.message || "Ocurrió un error.");
      }
    } catch (e) {
      toast.info("Error al guardar el producto.");
    }
  };

  // ===== ACCIONES =====
  onActualizar = () => this.fetchProductos();

  render() {
    const { loading, estatus, verProductos, banderatipo, selectedRowId } = this.state;
    const items = this.getSortedItems();

    return (
      <div className="p-page">
        <Navbar />

        {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

        {verProductos ? (
          <ProductoModal
            show={verProductos}
            mode={banderatipo}
            producto={this.state.productoSeleccionado}
            loading={this.state.loading}
            onClose={() => this.setState({ verProductos: false })}
            onSave={this.saveProducto}
          />
        ) : null}

        {this.state.verMensaje ? (
          <ModalMessage
            show={this.state.verMensaje}
            titulo={this.state.accionEstatus === "activar" ? "Activar producto" : "Deshabilitar producto"}
            bandera={this.state.accionEstatus === "activar" ? "activar" : "deshabilitar"}
            mensaje={this.state.modalMessage}
            cerrarBorrar={this.completaBorrar}
          />
        ) : null}

        <div className="p-shell">
          <div className="p-top">
            <h1 className="p-title">Productos</h1>

            <div className="p-actions">
              <div className="so-search">
                <span className="so-ico" aria-hidden="true">🔎</span>

                <input
                  type="text"
                  value={this.state.q}
                  onChange={(e) => this.setState({ q: e.target.value, selectedRowId: null })}
                  placeholder="Buscar SKU, Producto, Clave SAT..."
                  disabled={loading}
                />

                {String(this.state.q || "").length > 0 && (
                  <button
                    type="button"
                    className="so-clear"
                    onClick={() => this.setState({ q: "", selectedRowId: null })}
                    disabled={loading}
                    aria-label="Limpiar búsqueda"
                    title="Limpiar"
                  >
                    ✕
                  </button>
                )}
              </div>

              <div className="p-filter">
                <select value={estatus} onChange={this.onChangeEstatus}>
                  <option value="all">Todos</option>
                  <option value="1">Activos</option>
                  <option value="2">Inactivos</option>
                </select>
              </div>

              <button className="p-btn" onClick={this.onActualizar} disabled={loading}>
                ACTUALIZAR
              </button>

              <button className="p-btn p-btnAlt" onClick={this.nuevoProducto} disabled={loading}>
                AGREGAR PRODUCTO
              </button>
            </div>
          </div>

          <div className="pard">
            <div className="p-card">
              <div className="p-tableWrap">
                <table className="p-table">
                  <thead>
                    <tr>

                      <th className="p-thSort" onClick={() => this.onSort("sku")}>
                        SKU
                      </th>
                      <th className="p-thSort" onClick={() => this.onSort("producto")}>
                        Producto
                      </th>
                      <th className="p-thSort" onClick={() => this.onSort("clave_sat")}>
                        Clave SAT
                      </th>
                      <th className="p-thSort" onClick={() => this.onSort("estatus")}>
                        Estatus
                      </th>
                      <th>Acciones</th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="p-empty">
                          No hay registros disponibles
                        </td>
                      </tr>
                    ) : (
                      items.map((p, idx) => {
                        const isActive = selectedRowId === p._rowId;

                        return (
                          <tr
                            key={`${p._key}-${idx}`}
                            className={isActive ? "row-active" : ""}
                            onClick={() => this.onSelectRow(p._rowId)}
                            style={{ cursor: "pointer" }}
                          >

                            <td className="p-mono">{p.sku}</td>
                            <td className="p-prod">{p.producto}</td>
                            <td className="p-mono">{p.clave_sat}</td>
                            <td>
                              <span className={`p-badge ${Number(p.idestatus) === 1 ? "ok" : "warn"}`}>
                                {p.estatusTxt}
                              </span>
                            </td>

                            <td className="p-mono" onClick={(e) => e.stopPropagation()}>



                              <button
                                type="button"
                                className="a-linkBtn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.editarDetalles(p);
                                }}
                              >

                                <span>Editar</span>
                              </button>
                            </td>

                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              {/* ✅ paginación eliminada */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
